import tailwindColors from 'tailwindcss/colors'

export const baseColors = {
  // common
  inherit: tailwindColors.inherit,
  current: tailwindColors.current,
  transparent: tailwindColors.transparent,
  black: tailwindColors.black,
  white: tailwindColors.white,

  // reusable colors from Tailwind
  slate: tailwindColors.slate,
  gray: tailwindColors.gray,
  red: tailwindColors.red,
  yellow: tailwindColors.yellow,
  green: tailwindColors.green,
  cyan: tailwindColors.cyan,
  blue: tailwindColors.blue,
  indigo: tailwindColors.indigo,
  purple: tailwindColors.purple,
  pink: tailwindColors.pink,
  rose: tailwindColors.rose,
  violet: tailwindColors.violet,
  orange: tailwindColors.orange
}
